var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"24px"}},[_c('KCircularLoader',{attrs:{"type":"determinate","progress":75}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }